<template>
<div class="view-wrap">
	<Heading :level="1" text="Frequently Asked Questions" />

	<details>
		<summary>
			Q. I haven't received my verification email.
		</summary>
		<p class="m-t-1">If you saw a message to say that your verification email was on its way but haven't received it, try checking the junk/spam folder of your email provider in the first instance. If the email isn't there, you can try clicking the link to resend the email on the website.</p>
		<p>If you saw an error saying the email had failed to send, please try resending the email. If you get the same error again, please get in touch so that we can try to resolve the issue.</p>
	</details>

	<details>
		<summary>
			Q. I've forgotten my password.
		</summary>
		<p class="m-t-1">Please try to reset your password using the "forgotten your password" link on the log in page. You will then be asked for your email address to send a verification code to.</p>
	</details>

	<details>
		<summary>
			Q. My dashboard shows an error saying something went wrong retrieving my stage 1 application.
		</summary>
		<p class="m-t-1">If you have just created your account on the site, try refreshing the page in 5 minutes. If you're still unable to access your application, please get in touch so that we can try to resolve the issue.</p>
	</details>

	<details>
		<summary>
			Q. I get an error saying my postcode is out of scope for this grant.
		</summary>
		<p class="m-t-1">This means that the grant or scheme you are applying for is only available to businesses trading or registered in a certain area. If you believe that your postcode is in fact in the eligible area, please get in touch so that we can try to resolve the issue.</p>
	</details>

	<details>
		<summary>
			Q. I'm seeing an error saying "Please upload at least one document".
		</summary>
		<p class="m-t-1">You will see this error (or similar) if we need to collect uploaded files as evidence to support your application. If you think you have uploaded a file, please ensure that you have clicked the "Upload" button after selecting the file(s) you want to upload. The files are not added to your application until you do this. If you still see this message after uploading your files, please get in touch so that we can try to resolve the issue.</p>
	</details>

	<details>
		<summary>
			Q. I'm seeing an error saying "Please add at least one director/activity/job".
		</summary>
		<p class="m-t-1">You will see this error (or similar) if there is required information missing from the step. If you click the "Add director/activity/job" button a pop-up will open where you can save a new item. Until you have added at least one item, this error will show, and you will be unable to proceed.</p>
	</details>

	<details>
		<summary>
			Q.  I can't proceed to the next step when clicking "save and continue".
		</summary>
		<p class="m-t-1">If you are unable to proceed to the next step when clicking "save and continue", please follow the below steps before getting in touch:</p>
		<ol>
			<li>Check the top of the form for any error messages to do with missing files or other information and attempt to rectify the issue.</li>
			<li>Check any error messages that appear beneath the individual form fields for advice on how to provide a valid answer.</li>
			<li>Check the other fields on the page to ensure that none of them are empty. Sometimes the browser tries to help by prefilling fields and as a result, may have cleared other fields to match.</li>
		</ol>
		<p>If you are still unable to proceed, please click "save for later" to save your changes and get in touch so that we can try to resolve the issue.</p>
	</details>

	<details>
		<summary>
			Get in Touch.
		</summary>
		<p class="m-t-1">If you're still having difficulty completing your application, you can email us on durhambusinessgrowth@weareumi.co.uk. To help us help you as soon as possible, please try to provide the following information as appropriate:</p>
		<ol>
			<li>The email address you created your account with</li>
			<li>
				What point of your journey are you having difficulty with?
				<ol>
					<li>Creating an account</li>
					<li>Verifying your email address</li>
					<li>Changing your password</li>
					<li>Logging in to your account</li>
					<li>Viewing your applications on the dashboard</li>
					<li>Making changes to your stage 1 application</li>
					<li>Making changes to your stage 2 application</li>
					<li>Making changes to a claim</li>
					<li>Anything else you're struggling with</li>
				</ol>
			</li>
			<li>What are you expecting to happen, Vs what is happening. For example, "I expected to be able to proceed to the next step of the application form, but I wasn't able to"</li>
			<li>
				What errors or messages do you see on the page?
				<ol>
					<li>Did an error message appear beneath a particular field in the form? Which field was it and what did the message say?</li>
					<li>Did an error message appear elsewhere on the page, beneath the page title for example? Which step of the application was it and what did the message say?</li>
				</ol>
			</li>
		</ol>
		<p>If you're able to, take a screenshot of the page where you are having the issue and then click the "save for later" button so you don't lose your progress.</p>
	</details>
</div>
</template>

<script>
export default {
	name: 'FAQ',
	head: {
		title: `Frequently Asked Questions | ${process.env.VUE_APP_FUND_NAME}`,
		meta: [
			{ name: 'description', content: 'Got a question? Maybe we can help.' }
		]
	}
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/components/detailsSummary.scss';
</style>
